import {ValidationError} from '../../models/validation-error.model';
import {CpiOfferRecalculationRequest, CpiSalesConfiguration} from '../../models/offer.model';
import {SystemFile} from '../../models/system-file.model';
import {FilledQuestionnaire} from '../../models/questionnaire.model';

export namespace SalesCpiAction {

    export class GetProductList {
        static readonly type = 'SalesCpiAction.GetProductList';
    }

    export class CreateOffer {
        static readonly type = 'SalesCpiAction.CreateOffer';

        constructor(public productId: number) {
        }
    }

    export class GetOffer {
        static readonly type = 'SalesCpiAction.GetOffer';

        constructor(public offerId: number) {
        }
    }

    export class GetPolicy {
        static readonly type = 'SalesCpiAction.GetPolicy';

        constructor(public policyId: number) {
        }
    }

    export class GetAttachments {
        static readonly type = 'SalesCpiAction.GetAttachments';

        constructor(public policyId: number) {
        }
    }

    export class AddAttachment {
        static readonly type = 'SalesCpiAction.AddAttachment';

        constructor(public policyId: number, public file: SystemFile) {
        }
    }

    export class PolicyPrintout {
        static readonly type = 'SalesCpiAction.PolicyPrintout';

        constructor(public policyId: number, public single?: boolean) {
        }
    }

    export class DuplicatePrintout {
        static readonly type = 'SalesCpiAction.DuplicatePrintout';

        constructor(public policyId: number) {
        }
    }

    export class Simulate {
        static readonly type = 'SalesCpiAction.Simulate';

        constructor(public offerId: number, public configuration: CpiOfferRecalculationRequest) {
        }
    }

    export class SelectVariant {
        static readonly type = 'SalesCpiAction.SelectVariant';

        constructor(public offerId: number, public variantCode: string) {
        }
    }

    export class Issue {
        static readonly type = 'SalesCpiAction.Issue';

        constructor(public offerId: number, public configuration: CpiSalesConfiguration) {
        }
    }

    export class OpenPolicyModal {
        static readonly type = 'SalesCpiAction.OpenPolicyModal';
    }

    export class OpenCancellationAside {
        static readonly type = 'SalesCpiAction.OpenCancellationAside';
    }

    export class OpenTerminationAside {
        static readonly type = 'SalesCpiAction.OpenTerminationAside';
    }

    export class OpenBeneficiaryChangeAside {
        static readonly type = 'SalesCpiAction.OpenBeneficiaryChangeAside';
    }

    export class OpenPersonalDataChangeAside {
        static readonly type = 'SalesCpiAction.OpenPersonalDataChangeAside';
    }

    export class FormFailure {
        static readonly type = 'SalesCpiAction.FormFailure';

        constructor(public readonly validationErrors: ValidationError[]) {
        }
    }

    export class GetQuestionnaire {
        static readonly type = 'SalesCpiAction.GetQuestionnaire';
    }

    export class ValidateQuestionnaire {
        static readonly type = 'SalesCpiAction.ValidateQuestionnaire';

        constructor(public payload: FilledQuestionnaire) {
        }
    }
    export class ClearSalesForm {
        static readonly type = 'SalesCpiAction.ClearSalesForm';
    }
}
